import { MediaType } from '../media-types';
import { startsWith } from '../str-buf/utils';

const simpleMagics: [MediaType, Buffer][] = [
	[MediaType.Pdf, Buffer.from('%PDF-', 'latin1')],

	[MediaType.Png, Buffer.from('89504E470D0A1A0A', 'hex')],

	// ÿØÿà\x00\x10JFIF\0
	[MediaType.JPEG, Buffer.from('FFD8FFE000104A46494600', 'hex')],
	// ÿØÿá\x3F\xFEExif\0
	[MediaType.JPEG, Buffer.from('FFD8FFE13FFE4578696600', 'hex')],

	[MediaType.Tiff, Buffer.from('II*\0', 'latin1')],
	[MediaType.Tiff, Buffer.from('MM\0*', 'latin1')],

	[MediaType.GIF, Buffer.from('GIF87a', 'latin1')],
	[MediaType.GIF, Buffer.from('GIF89a', 'latin1')],
	[MediaType.Bmp, Buffer.from('BM', 'latin1')],

	[MediaType.Zip, Buffer.from('504B0304', 'hex')],
	[MediaType.Woff, Buffer.from('wOFF', 'latin1')],
	[MediaType.Woff2, Buffer.from('wOF2', 'latin1')],

	[MediaType.Html, Buffer.from('<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n\r\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\uFEFF<html>', 'utf8')],

	[MediaType.Html, Buffer.from('<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n\r\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\uFEFF<HTML>', 'utf8')],

	[MediaType.Xhtml, Buffer.from('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1')],
	[MediaType.Xhtml, Buffer.from('\r\n<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1')],
	[
		MediaType.Xhtml,
		Buffer.from('\r\n\r\n<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1'),
	],
	[MediaType.Xhtml, Buffer.from('\n<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1')],
	[MediaType.Xhtml, Buffer.from('\n\n<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1')],

	// HTML 5
	[MediaType.Html, Buffer.from('<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\uFEFF<!DOCTYPE html>', 'utf8')],

	[MediaType.Bplist, Buffer.from('bplist00', 'latin1')],
	[MediaType.AppleDouble, Buffer.from('0005160700020000', 'hex')],

	[MediaType.Wmf, Buffer.from('D7CDC69A0000', 'hex')],
	[MediaType.Wmf, Buffer.from('010009000001', 'hex')],
	[MediaType.Wmf, Buffer.from('010009000003', 'hex')],

	[MediaType.Ole1, Buffer.from('0105000002000000', 'hex')],
	[MediaType.Ole1, Buffer.from('0105000001000000', 'hex')],

	[MediaType.Rtf, Buffer.from('{\\rtf1\\', 'latin1')],

	[MediaType.JBIG2, Buffer.from('—JB2\r\n\x1A\n', 'latin1')],

	[MediaType.Rtfd, Buffer.from('rtfd\0\0\0\0\x03\0\0\0', 'latin1')],

	// PS or EPS
	[MediaType.PostScript, Buffer.from('%!PS-Adobe-', 'binary')],
	// EPS with preview
	[MediaType.PostScript, Buffer.from('C5D0D3C6', 'hex')],
];

export function simpleMagic(buf: Buffer): MediaType | undefined {
	for (const [mediaType, sig] of simpleMagics) {
		if (startsWith(buf, sig)) {
			return mediaType;
		}
	}
}
